import { render, staticRenderFns } from "./batchAuditList.vue?vue&type=template&id=564319fc&scoped=true&"
import script from "./batchAuditList.vue?vue&type=script&lang=js&"
export * from "./batchAuditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564319fc",
  null
  
)

export default component.exports